<template>
  <transition name="fade">
    <div v-if="show" style="padding: 8px">

        <div style="text-align: center; font-weight: bold; background-color: rgba(0,0,0,0.05); padding: 10px 0px">{{ store.datasets.importantVariants[index]['_id'].aaVar }}</div>
        <div class="echarts" :style="`height: 150px; min-height: 80px`" >
          <v-chart :option='scatterOptions' :resizable="true" theme="infographic" @datazoom="zoomCallback"></v-chart>
        </div>

        
        <div class="echarts" style="width: 100%; height: 350px" >
          <v-chart :option='geomapOptions'  :id="`variant-geomap-${index}`" :resizable="true" theme="infographic"></v-chart>
        </div>
    </div>
  </transition>
</template>

<script>
import { store } from '@/scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'


const _ = require('lodash')
const echarts = require('echarts')

export default {
  name: 'ImportantVariantsTimeline',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return { 
      store: store, 
      scatterOptions: {},
      show: false,
      startDate: 0,
      endDate: 0,
      filterStartDate: 0,
      filterEndDate: 0,
    }
  },
  props: {
    height: String,
    index: Number,
  },
  async mounted() {
    const context = this
    this.loadChart()
    setTimeout(() => { context.show = true }, 500*(context.index))
  },
  methods: {
    loadChart: function() {
      const colors = [ '#488f31', '#821f60', '#222a82', '#2b6b5b']

      const context = this
      const variantFrequency = store.datasets.importantVariants[context.index]
      
      const variant = variantFrequency['_id'].aaVar
      const variants = [variant]
      
      const dateCounts = {}
      const dates = (_.uniq(variantFrequency.date)).sort()

      context.startDate = Date.parse(dates[0])
      context.filterStartDate = Date.parse(dates[0])
      context.endDate = Date.parse(dates[dates.length - 1])
      context.filterEndDate = Date.parse(dates[dates.length - 1])
      
      variantFrequency.date.forEach((o, i) => {
        if (o in dateCounts) { dateCounts[o] += variantFrequency.count[i] }
        else { dateCounts[o] = variantFrequency.count[i] }
      })

      const scatterPlotData = []
      dates.forEach(d => { scatterPlotData.push([d, variant, dateCounts[d]]) })
      const series = [{
        data: scatterPlotData,
        type: 'scatter', symbolSize: function(val) { return 8 + val[2] },
        itemStyle: { opacity: 0.6, borderColor: "#dedede", color: '#9c1d1d', borderWidth: 1.5 }
      }]

      context.scatterOptions = {
        tooltip: { 
          show: true, trigger: 'axis', axisPointer: { type: 'shadow' }, 
          position: function (point, params, dom, rect, size) {
            const top= (size.viewSize[1] - size.contentSize[1])/2
            return [point[0], top];
          },
          formatter: function(data) {
            const monthCounts = {}
            data.forEach( d => { 
              const year = d.data[0].split('-')[0]
              const month = store.constants.months[parseInt(d.data[0].split('-')[1]) - 1]
              const key = `${year} ${month}`
              if (key in monthCounts) {
                monthCounts[key] += parseInt(d.data[2])
              }
              else { monthCounts[key] = parseInt(d.data[2]) }
            })

            let content = ''
            for (let key in monthCounts) {
              content += `<div>${key}: ${monthCounts[key]}</div>`
            }
            
            return content
          },
          textStyle: { color: '#4e4e4e', fontFamily: store.theme.fontFamily.plotTooltip, fontWeight: 'normal' }, padding: 10, 
          backgroundColor: '#ffffff'
        },
        dataZoom: [{
          type: 'slider', xAxisIndex: 0,
          height: 5, bottom: 10, handleSize: '300%',
          backgroundColor: 'rgba(233, 71, 49, 0.5)',
          borderColor: '#4e4e4e',
          handleIcon: "M10.467,146.589l198.857,252.903c17.418,30.532,45.661,30.532,63.079,0l198.839-252.866    c3.88-5.533,8.072-15.41,8.923-22.118c2.735-21.738,4.908-65.178-21.444-65.178H23.013c-26.353,0-24.192,43.416-21.463,65.147    C2.395,131.185,6.587,141.051,10.467,146.589z",
          dataBackground: {
            lineStyle: { shadowColor: '#2F7780', opacity: 0 },
            areaStyle: { color: 'blue', shadowColor: '#4e4e4e', opacity: 0 }
          }, realtime: false,
          fillerColor: 'rgba(150, 150, 150, 0.3)',
          handleStyle: { color: '#4e4e4e', },
          startValue: Date.parse(dates[0]), endValue: Date.parse(dates[dates.length - 1]),
          filterMode: 'filter', rangeMode: ['value', 'value'],
        }],
        grid: [{ left: 20, right: 20 }],
        textStyle: { fontFamily: store.theme.fontFamily.content, fontWeight: 'bold' },
        xAxis: { type: 'time', axisLine: { lineStyle: { opacity: 0.6, color: '#4e4e4e' } } },
        yAxis: { data: variants, axisLabel: { show: false, fontSize: 18 }, axisLine: { show: false } },
        series: series,
        resize: true, animation: true,
      }
    },
    zoomCallback: function(val) {
      let startVal = 0
      let endVal = 0
      if (val.batch === undefined) {
        startVal = val.start; endVal = val.end;
      } else {
        startVal = val.batch[0].start; endVal = val.batch[0].end;        
      }
      const context = this
      const diff = context.endDate - context.startDate
      const start = Math.round(context.startDate + (diff*startVal)/100)
      const end = Math.round(context.startDate + (diff*endVal)/100)

      context.filterStartDate = start
      context.filterEndDate = end
    }
  },
  computed: {
    geomapOptions() {

      const indiaMap = store.maps.india.states
      echarts.registerMap('india', indiaMap)

      const context = this
      const variantFrequency = store.datasets.importantVariants[context.index]

      const stateCounts = {}
      const states = (_.uniq(variantFrequency.state))
      const totalStateCounts = {}
      variantFrequency.state.forEach((o, i) => {
        const date = Date.parse(variantFrequency.date[i])
        if ( context.filterStartDate <= date && date <= context.filterEndDate) {
          if (o in stateCounts) {stateCounts[o] += variantFrequency.count[i] }
          else { stateCounts[o] = variantFrequency.count[i] }
        }
        if (o in totalStateCounts) { totalStateCounts[o] += variantFrequency.count[i] }
        else { totalStateCounts[o] = variantFrequency.count[i] }
      })
      
      const geomapPlotData = []
      let maxCount = 0
      states.forEach((o,i) => {
        if (totalStateCounts[o] > maxCount) { maxCount = totalStateCounts[o] }
        geomapPlotData.push({name: o, value: stateCounts[o]})
      })


      return {
        textStyle: { fontFamily: store.theme.fontFamily.content },
        toolbox: {
          feature: {  
            saveAsImage: { title: 'Save as PNG', show: true, type: 'png', name: 'StateContributions_Map' },
          }
        },
        emphasis: {
          show: false,
          label: { fontWeight: 'bold' }
        },
        // tooltip: {
          // trigger: 'item', showDelay: 0, transitionDuration: 0.2,
          // formatter: function (params) {
          //   const val = (isNaN(params.value)) ? 0 : params.value
          //   return params.name + '<br/>' + params.seriesName + ': ' + val;
          // },
          // textStyle: { fontWeight: 'bold' }
        // },
        visualMap: {
          left: 10, bottom: 20, min: 0, max: maxCount, orient: 'vertical',
          itemWidth: 8, itemHeight: 50, seriesIndex: [0],
          inRange: { color: ['#ffc72e', '#b00505']},
          text: ['Max', 'Min'], calculable: true, 
          textStyle: { fontWeight: 'bold' }
        },
        geo:{
          id: 'country', show: true, map: 'india', aspectScale: 0.9, zoom: 1, roam: false, 
          itemStyle: { borderColor: '#919191', borderWidth: 1.4, borderType: 'dotted', areaColor: 'rgba(255,255,255,0.3)'},
          emphasis:{
            itemStyle: { areaColor: '#dedede', shadowOffsetX: 0, shadowOffsetY: 0, shadowBlur: 20, borderWidth: 0, shadowColor: '#6e6e6e' }
          },
        },
        series: [
          { 
            type: 'map', name: '#Genomes', geoIndex: 0, data: geomapPlotData,
          },
        ], resize: true,
      }
    }
  }
}
</script>

<style>
  
</style>